<template>
  <form
    id="form-card"
    class="form"
    :class="{ 'px-i': !noPadding, 'p-0': noPadding }"
    @submit="submitForm($event)">
    <fieldset class="form-wrapper container-fluid" :disabled="formDisabled">
      <slot />
      <div v-if="showButtons" class="form-controls">
        <router-link
          v-if="cancelEnabled"
          role="button"
          :disabled="cancelDisabled"
          class="btn btn-info ihjoz-button"
          :class="cancelButtonClass"
          to=""
          @click.native.prevent="confirm">
          {{ this.$t("common.cancel") }}
        </router-link>
        <slot name="additionalButtons" />
        <button
          type="submit"
          class="btn btn-form ihjoz-button"
          :name="createButtonText"
          :class="createButtonClass"
          :disabled="submitDisabled || processing"
          @click="submitClicked($event)">
          {{ createButtonText || submitButtonName() }}
        </button>
      </div>
    </fieldset>

    <div v-if="value && value.id && destroy" class="card form-destroy px-i">
      <h3 class="form-destroy-title">
        {{ destroyTitle }}
      </h3>
      <p class="form-destroy-disclaimer" v-html="destroyDisclaimer" />
      <div class="form-destroy-controls">
        <div class="form-destroy-controls-checkbox custom-checkbox">
          <input
            id="destroy-confirm"
            v-model="checked"
            class="custom-checkbox-input"
            type="checkbox">
          <label for="destroy-confirm" class="custom-checkbox-label">
            <span class="custom-checkbox-label-text">{{
              destroyCheckboxLabel
            }}</span>
          </label>
        </div>
        <button
          type="button"
          :disabled="!checked"
          class="btn btn-danger ihjoz-button"
          @click="clickDestroy($event)">
          {{ destroyButtonText }}
        </button>
      </div>
    </div>
  </form>
</template>

<script>
import ResponseStore from "@shared/stores/ResponseStore";

export default {
  props: {
    value: { type: Object, default: () => {} },
    destroy: { type: Boolean },
    submitDisabled: { type: Boolean, default: false },
    cancelDisabled: { type: Boolean, default: false },
    formDisabled: { type: Boolean, default: false },
    showButtons: { type: Boolean, default: true },
    errorMessages: { type: Array, default: () => [] },
    successMessage: { type: Array, default: () => [] },
    destroyTitle: { type: String },
    createButtonText: { type: String },
    createButtonClass: { type: String },
    cancelButtonText: { type: String, default: "Cancel" },
    cancelButtonClass: { type: String },
    destroyButtonText: { type: String, default: "Cancel" },
    destroyDisclaimer: { type: String },
    destroyCheckboxLabel: { type: String },
    noPadding: { type: Boolean, default: false },
    cancelEnabled: { type: Boolean, default: true },
    addCustomButton: { type: Boolean, default: false }
  },

  data: function () {
    return {
      checked: false,
      responseStoreState: ResponseStore.state
    };
  },

  computed: {
    processing () {
      return this.responseStoreState.processing;
    }
  },

  methods: {
    submitClicked (e) {
      this.$emit("submitClicked", e);
    },

    submitForm (e) {
      e.preventDefault();
      ResponseStore.startProcessing();
      this.$emit("formSubmit", e);
    },

    clickDestroy (e) {
      this.$emit("destroyClick", e);
    },

    submitButtonName () {
      return (this.value && this.value.id) ? this.$t("common.save") : this.$t("common.create");
    },

    confirm: function (e) {
      if (window.confirm(this.$t("common.confirmDiscardChanges"))) {
        this.$router.back();
      } else {
        e.preventDefault();
      }
    }
  }
};
</script>
